import {
  type AppLanguage,
  isAppLanguage,
} from '@/shared/lib/appLanguageSupports';

/**
 * The same page under another language. `en` is the default language and
 * carries no `($lang)` segment, so it is dropped — the same rule
 * `localizeHref` and `getMultiLanguagePage` follow.
 *
 * Works off the pathname rather than `href()`, which needs a route pattern
 * (`/:lang?/community`) that is not recoverable from a match at runtime.
 */
export function buildAppLanguagePath(pathname: string, language: AppLanguage) {
  const [, first = '', ...rest] = pathname.split('/');
  const segments = isAppLanguage(first) ? rest : [first, ...rest];
  const prefix = language === 'en' ? [] : [language];

  return `/${[...prefix, ...segments].join('/')}`;
}
